<template>
  <div>
    <div v-for="(order,index) in orderList" class="content-block">
      <div @click="goToOrderDetail(order)" :id="order.id">
        <div class="block-item" style="height: 35px;">
          <span class="deep-text-color" :lines="undefined">订单编号：{{ order.orderNo }}</span>
          <div style="display: flex; align-items: center">
        <span :class="getStatusStyle(order)">
          {{ getOrderStatusText(order) }}</span>
            <i class="icon-font emkt-icon-lujing" style="font-size: 12px;"></i>
          </div>
        </div>
        <div class="full-split-line"></div>
        <div v-if="order.balanceType === emkt.BALANCE_TYPE_RESEARCH_GROUP">
          <div class="block-item" style="height: 35px;">
            <span class="deep-text-color" :lines="undefined">{{ order.orderPerson }}</span>
            <span class="light-text-color" :lines="undefined">结算账户：{{ order.researchGroupName }}</span>
          </div>
          <div class="full-split-line"></div>
        </div>
        <div v-for="(item,i) in order.itemList">
          <gc-order-product :item="item" :order="order" :show-product-contract-no="showProductContractNo"></gc-order-product>
        </div>
        <div class="full-split-line"/>
      </div>
      <div class="block-item" style="height: 35px;">
        <span class="light-text-color" :lines="undefined">{{ order.orderTime }}</span>
        <div class="light-text-color">
          <span class="light-text-color" :lines="undefined">共{{ order.itemList.length }}件商品</span>
          <span class="light-text-color" :lines="undefined">合计</span>
          <span class="research-font-color" :lines="undefined">￥{{ emkt.formatPrice(order.price) }}</span>
        </div>
      </div>
      <div class="block-item" style="height: 35px;justify-content: flex-end;align-items: flex-start;flex-wrap:wrap;">
        <slot name="itemButton" v-bind="order"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import EMKT from '../../../constant'
import GcOrderProduct from '../../product/components/GcOrderProductBase.vue'
// import $ from 'jquery'
export default {
  props: {
    orderList: Array,
    showProductContractNo: Boolean
  },
  emits: ['goToOrderDetail'],
  components: { GcOrderProduct },
  data () {
    return {
      emkt: EMKT
    }
  },
  mounted () {
  },
  computed: {},
  methods: {
    getOrderStatusText: EMKT.getOrderStatusText,
    getStatusStyle: EMKT.getStatusStyle,
    stringSet (str) {
      if (str) {
        let s = str.replace(/&nbsp;/ig, ' ')
        return s
      } else {
        return ''
      }
    },
    goToOrderDetail: function (order) {
      EMKT.setLocalStorage('currentOrderDetail', order)
      this.$emit('goToOrderDetail', order)
    }
  }
}
</script>

<style scoped>

.content-block {
  position: relative;
  margin-top: 0;
  margin-bottom: 10px;
  padding: 0 15px;
  border-radius: 10px;
  /*width: 100%;*/
  border: 0.5px solid #EFEEF3;
  background-color: #fff;
}


row {
  position: relative;
  margin-top: 2.4vw;
  border-top-width: 0.7px;
  border-top-style: solid;
  border-top-color: rgba(239, 238, 243, 1);
  width: 94.67vw;
  height: 0.27vw;
}

/* !!important!! order status style start --------------------*/
.alert-background {
  background-color: #FE654D;
}

.orange-background {
  background-color: #FF9401;
}

.green-background {
  background-color: #2ac845;
}

.tiny-font {
  font-size: 12px;
  transform: scale(0.8);
  transform-origin: right center;
}

.order-status {
  /*width:80px;*/
  margin-right: 10px;
  padding: 0 10px;
  line-height: 18px;
  height: 18px;
  border-radius: 10px;
  color: #fff;
  text-align: right;
  float: right;
}

/*!!important!! order status style end -----------------------------*/


.return-btn {
  width: 73px;
  height: 23px;
  border-radius: 44px;
  line-height: 21px;
  text-align: center;
  font-size: 12px;
  background-color: #fff;
  border: 1px solid #5878fa;
}

.deep-text-color {
  color: #424242;
  font-size: 12px;
  /*font-weight: 500;*/
  font-weight: bold;
}

.block-item {
  /*height: 35px;*/
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background-color: #fff;
}

.full-split-line {
  border-top: .5px solid #efeef3;
  margin-right: -15px;
  margin-left: -15px;
  height: 1px;
}

.light-text-color {
  color: #929292;
  font-size: 12px;
}

</style>



// WEBPACK FOOTER //
// GcOrderListBase.vue?59f58d2b